/** Ortak eğitim kuralları. Bilgi puanı yalnız doğru cevaptan gelir; keşif bonusu (UFO_BONUS) ayrı tutulur ve sunucuda olay sırasından yeniden hesaplanır. */
export const UFO_RULES = {
  minQuestions: 5, maxQuestions: 20, minChoices: 2, maxChoices: 4,
  correctScore: 100, feedbackMs: 2000, cruiseMs: 3200, arrivalMs: 1800,
  defaultApproachSeconds: 20, minApproachSeconds: 10, maxApproachSeconds: 120,
  selectionApproachMs: 1800, commitMs: 350, laneChangeMs: 300,
  startGateX: 0.86, contactX: 0.25, cruiseSpeed: 0.075,
} as const;
export type UfoTimingMode = 'none' | 'per-question';
export function ufoScore(correct: boolean) { return correct ? UFO_RULES.correctScore : 0; }

/**
 * Sorular arası seyirde toplanan yıldız (+) ve çarpılan göktaşı (−) keşif bonusu. Bilgi puanından ayrıdır;
 * bonus hiçbir zaman sıfırın altına inmez, dolayısıyla doğru cevap puanını azaltamaz.
 */
export const UFO_BONUS = { starScore: 10, asteroidPenalty: 10, starsPerCruise: 3, asteroidsPerCruise: 2 } as const;
export type UfoBonusEvent = 'star' | 'asteroid';
export function applyUfoBonusEvent(points: number, event: UfoBonusEvent) {
  return event === 'star' ? points + UFO_BONUS.starScore : Math.max(0, points - UFO_BONUS.asteroidPenalty);
}
/** İstemci ve sunucunun aynı sonucu üretmesi için seyir olaylarını sırasıyla yeniden oynatır. */
export function replayUfoBonus(cruises: readonly (readonly UfoBonusEvent[])[]) {
  let points = 0, stars = 0, asteroidHits = 0;
  for (const cruise of cruises) for (const event of cruise) {
    points = applyUfoBonusEvent(points, event);
    if (event === 'star') stars += 1; else asteroidHits += 1;
  }
  return { points, stars, asteroidHits };
}
